

import { SCROLL_ACTIVATE_THRESHOLD } from '../../base/config.js'; 

export function initParallaxAni(options = {}) {
  const defaults = {
    hero: {
      enabled: true,
      bgSelector: '.hero-bg-layer, .hero-swiper',
      textSelector: '.hero-text-area',
      maxScale: 1.1,
      maxShiftX: 0.05,
      baseDivScale: 6000,
      baseDivShift: 12500,
      textMinScale: 0.9,
      textScaleDivisor: 6000,
      textOpacityDivisor: 1000,
      textTransformOrigin: 'top left',
      vwRef: 1200,
      maxFactor: 1.8,
      pow: 0.4,
      onlyWhenVisible: true,
      emulateFixed: false,
      keepZoomShiftOnFixed: false,
      sectionClipSelector: '[data-ani-section], section'
    },
    fadeparaZoom: {
      enabled: true,
      sectionSelector: '.ani-fadepara-section.ani-fadepara-zoom',
      bgSelector: '.ani-fadepara-section-bg',
      maxExtraScale: 0.2,
      maxTranslateY: -40,
      thresholdsSteps: 100,
    },
    fadeparaX: {
      enabled: true,
      sectionSelector: '.ani-fadepara-section.ani-fadepara-x',
      bgSelector: '.ani-fadepara-section-bg',
      maxShiftPx: 100,
      thresholdsSteps: 100,
    },
    scrollActivate: {
      enabled: true,
      sectionSelector: '.scroll-activate',
      rootMargin: '-280px 0px -280px 0px',
      activeClass: 'is-active',
    },
  };

  const cfg = deepMerge(defaults, options);
  const cleanups = [];

  if (cfg.hero?.enabled) cleanups.push(initHeroParallax(cfg.hero));
  if (cfg.fadeparaZoom?.enabled) cleanups.push(initFadeparaZoom(cfg.fadeparaZoom));
  if (cfg.fadeparaX?.enabled) cleanups.push(initFadeparaX(cfg.fadeparaX));
  if (cfg.scrollActivate?.enabled) cleanups.push(initScrollActivate(cfg.scrollActivate));

  return () => { for (const off of cleanups) { try { off && off(); } catch (_) {} } };
}


function initHeroParallax(options = {}) {
  const defaults = {
    bgSelector: '.hero-bg-layer, .hero-swiper',
    textSelector: '.hero-text-area',
    maxScale: 1.1,
    maxShiftX: 0.05,
    baseDivScale: 6000,
    baseDivShift: 12500,
    textMinScale: 0.9,
    textScaleDivisor: 6000,
    textOpacityDivisor: 1000,
    textTransformOrigin: 'top left',
    vwRef: 1200,
    maxFactor: 1.8,
    pow: 0.4,
    onlyWhenVisible: true,
    emulateFixed: false,
    keepZoomShiftOnFixed: false,
    sectionClipSelector: '[data-ani-section], section'
  };
  const cfg = { ...defaults, ...options };

  const heroSec = document.getElementById('section-hero');
  if (heroSec) {
    const attrVal = heroSec.getAttribute('data-hero-fixed');
    if (attrVal === 'true') cfg.emulateFixed = true;
    if (attrVal === 'false') cfg.emulateFixed = false;
    if (!heroSec.style.overflow) heroSec.style.overflow = 'clip';
  }

  const bgEls = document.querySelectorAll(cfg.bgSelector);
  const textEl = document.querySelector(cfg.textSelector);
  if (!bgEls.length && !textEl) return () => {};

  let factor = 1;
  const computeFactor = () => {
    const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    factor = Math.min(cfg.maxFactor, Math.max(1, Math.pow(cfg.vwRef / Math.max(vw, 1), cfg.pow)));
  };
  computeFactor();

  const pairs = Array.from(bgEls).map(el => {
    const sec = el.closest(cfg.sectionClipSelector) || document.body;
    if (!el.style.position) el.style.position = 'absolute';
    if (!el.style.inset) el.style.inset = '0';
    if (!el.style.width) el.style.width = '100%';
    if (!el.style.height) el.style.height = '100%';
    el.style.backfaceVisibility = 'hidden';
    el.style.willChange = 'transform';
    return { el, sec, secTopAbs: 0, secHeight: 0 };
  });

  let visible = true, io;
  if (cfg.onlyWhenVisible && 'IntersectionObserver' in window) {
    const targets = [...bgEls, ...(textEl ? [textEl] : [])];
    io = new IntersectionObserver((entries) => {
      visible = entries.some(e => e.isIntersecting);
    }, { root: null, threshold: 0 });
    targets.forEach(el => io.observe(el));
  }

  function measure() {
    const y = window.scrollY || 0;
    pairs.forEach(p => {
      const r = p.sec.getBoundingClientRect();
      p.secTopAbs = r.top + y;
      p.secHeight = r.height || p.sec.offsetHeight || 0;
    });
  }
  measure();

  let ticking = false;

  function update() {
    if (!visible) { ticking = false; return; }
    const y = window.scrollY || 0;

    if (pairs.length) {
      pairs.forEach(p => {
        const el = p.el;

        const maxScaleBase  = parseFloat(el.dataset.parallaxMaxScale)  || cfg.maxScale;
        const maxShiftXBase = parseFloat(el.dataset.parallaxMaxShiftX) || cfg.maxShiftX;
        const baseDivScale  = parseFloat(el.dataset.parallaxDivScale)  || cfg.baseDivScale;
        const baseDivShift  = parseFloat(el.dataset.parallaxDivShift)  || cfg.baseDivShift;

        const maxScaleEff = 1 + (maxScaleBase - 1) * factor;
        const maxShiftEff = maxShiftXBase * factor;
        const divScale = baseDivScale / factor;
        const divShift = baseDivShift / factor;

        const zoomClassic   = 1 + Math.min(y / divScale,  maxScaleEff - 1);
        const shiftXClassic = Math.min(y / divShift, maxShiftEff) * 100;

        
        
        
        
        let tFixedY = 0;
        if (cfg.emulateFixed) {
          const start = p.secTopAbs;
          const end   = p.secTopAbs + p.secHeight;
          if (y <= start) {
            tFixedY = 0;
          } else if (y >= end) {
            tFixedY = p.secHeight;
          } else {
            tFixedY = y - start;
          }
        }

        if (cfg.emulateFixed && !cfg.keepZoomShiftOnFixed) {
          el.style.transform = `translate3d(0, ${tFixedY}px, 0)`;
        } else if (cfg.emulateFixed && cfg.keepZoomShiftOnFixed) {
          el.style.transform = `translate3d(0, ${tFixedY}px, 0) scale(${zoomClassic}) translateX(-${shiftXClassic}%)`;
        } else {
          el.style.transform = `scale(${zoomClassic}) translateX(-${shiftXClassic}%)`;
        }
      });
    }

    if (textEl) {
      const textDiv = cfg.textScaleDivisor / factor;
      const opDiv   = cfg.textOpacityDivisor;
      const scale = Math.max(cfg.textMinScale, 1 - (y / textDiv));
      const opacity = Math.max(0, 1 - (y / opDiv));
      textEl.style.transformOrigin = cfg.textTransformOrigin;
      textEl.style.transform = `scale(${scale})`;
      textEl.style.opacity = opacity;
      textEl.style.willChange = 'transform, opacity';
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  let resizeTick = false;
  function onResize() {
    if (!resizeTick) {
      resizeTick = true;
      requestAnimationFrame(() => {
        computeFactor();
        measure();
        update();
        resizeTick = false;
      });
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });

  requestAnimationFrame(() => { measure(); update(); });

  return () => {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onResize);
    if (io) io.disconnect();
  };
}


function initFadeparaZoom(options = {}) {
  const defaults = {
    sectionSelector: '.ani-fadepara-section.ani-fadepara-zoom',
    bgSelector: '.ani-fadepara-section-bg',
    maxExtraScale: 0.2,
    maxTranslateY: -40,
    thresholdsSteps: 100,
  };
  const cfg = { ...defaults, ...options };

  const targets = document.querySelectorAll(cfg.sectionSelector);
  if (!targets.length || !('IntersectionObserver' in window)) return () => {};
  const thresholds = Array.from({ length: cfg.thresholdsSteps + 1 }, (_, i) => i / cfg.thresholdsSteps);

  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const sec = e.target;
      const bg = sec.querySelector(cfg.bgSelector);
      if (!bg) return;

      let r = e.intersectionRatio;
      r = r > SCROLL_ACTIVATE_THRESHOLD
        ? (r - SCROLL_ACTIVATE_THRESHOLD) / (1 - SCROLL_ACTIVATE_THRESHOLD)
        : 0;
      r = Math.min(Math.max(r, 0), 1);

      const zoom = 1 + r * cfg.maxExtraScale;
      const ty = r * cfg.maxTranslateY;
      bg.style.transform = `scale(${zoom}) translateY(${ty}px)`;
      bg.style.willChange = 'transform';
    });
  }, { root: null, threshold: thresholds });

  targets.forEach((el) => obs.observe(el));
  return () => obs.disconnect();
}


function initFadeparaX(options = {}) {
  const defaults = {
    sectionSelector: '.ani-fadepara-section.ani-fadepara-x',
    bgSelector: '.ani-fadepara-section-bg',
    maxShiftPx: 100,
    thresholdsSteps: 100,
  };
  const cfg = { ...defaults, ...options };

  const targets = document.querySelectorAll(cfg.sectionSelector);
  if (!targets.length || !('IntersectionObserver' in window)) return () => {};
  const thresholds = Array.from({ length: cfg.thresholdsSteps + 1 }, (_, i) => i / cfg.thresholdsSteps);

  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const sec = e.target;
      const bg = sec.querySelector(cfg.bgSelector);
      if (!bg) return;

      let r = e.intersectionRatio;
      r = r > SCROLL_ACTIVATE_THRESHOLD
        ? (r - SCROLL_ACTIVATE_THRESHOLD) / (1 - SCROLL_ACTIVATE_THRESHOLD)
        : 0;
      r = Math.min(Math.max(r, 0), 1);

      const tx = (r * 2 - 1) * cfg.maxShiftPx;
      bg.style.transform = `translateX(${tx}px)`;
      bg.style.willChange = 'transform';
    });
  }, { root: null, threshold: thresholds });

  targets.forEach((el) => obs.observe(el));
  return () => obs.disconnect();
}


function initScrollActivate(options = {}) {
  const defaults = {
    sectionSelector: '.scroll-activate',
    rootMargin: '-280px 0px -280px 0px',
    activeClass: 'is-active',
  };
  const cfg = { ...defaults, ...options };

  const targets = document.querySelectorAll(cfg.sectionSelector);
  if (!targets.length || !('IntersectionObserver' in window)) return () => {};

  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      entry.target.classList.toggle(
        cfg.activeClass,
        entry.intersectionRatio >= SCROLL_ACTIVATE_THRESHOLD
      );
    });
  }, {
    root: null,
    rootMargin: cfg.rootMargin,
    threshold: SCROLL_ACTIVATE_THRESHOLD
  });

  targets.forEach((el) => obs.observe(el));
  return () => obs.disconnect();
}






function deepMerge(base, extra) {
  const out = Array.isArray(base) ? [...base] : { ...base };
  if (!extra || typeof extra !== 'object') return out;
  for (const k of Object.keys(extra)) {
    const bv = base?.[k];
    const ev = extra[k];
    if (isPOJO(bv) && isPOJO(ev)) {
      out[k] = deepMerge(bv, ev);
    } else {
      out[k] = ev;
    }
  }
  return out;
}
function isPOJO(v) {
  return v && typeof v === 'object' && !Array.isArray(v);
}
